import { c as _c } from "react/compiler-runtime";
import { CaseStudyProps } from "@/lib/types";
import CaseStudyImageHover from "../../animations/CaseStudyImageHover";
import SectionTitle from "../titles/SectionTitle";
import ViewCaseStudyLink from "./ViewCaseStudyLink";
interface CardProps {
  data: CaseStudyProps;
}
const CaseStudyCard = t0 => {
  const $ = _c(30);
  const {
    data
  } = t0;
  let t1;
  if ($[0] !== data.name || $[1] !== data.title) {
    t1 = data.name ?? data.title.split(/[—–]/)[0].trim().toLowerCase().replace(/\b\w/g, _temp);
    $[0] = data.name;
    $[1] = data.title;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const projectName = t1;
  const caseLabel = `View ${projectName} Case Study`;
  let t2;
  if ($[3] !== data.bgColor) {
    t2 = {
      backgroundColor: data.bgColor
    };
    $[3] = data.bgColor;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const t3 = `flex flex-col lg:gap-12 justify-between lg:justify-between w-full md:w-[45%] lg:pb-10 lg:w-[42%] ${data.bgColor}`;
  const t4 = data?.tag;
  let t5;
  if ($[5] !== t4) {
    t5 = <p className="text-sm font-semibold tracking-wide uppercase mb-20 md:mb-0">{t4}</p>;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== data.title) {
    t6 = <SectionTitle title={data.title} className="text-3xl md:text-4xl lg:text-4xl lg:line-clamp-4" />;
    $[7] = data.title;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const t7 = data?.description;
  let t8;
  if ($[9] !== t7) {
    t8 = <p className="text-sm lg:text-base font-medium opacity-80 max-w-[320px]">{t7}</p>;
    $[9] = t7;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  const t9 = `/case-study/${data.slug}`;
  let t10;
  if ($[11] !== caseLabel || $[12] !== t9) {
    t10 = <ViewCaseStudyLink href={t9} label={caseLabel} />;
    $[11] = caseLabel;
    $[12] = t9;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== t10 || $[15] !== t6 || $[16] !== t8) {
    t11 = <div className="space-y-8">{t6}{t8}{t10}</div>;
    $[14] = t10;
    $[15] = t6;
    $[16] = t8;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== t11 || $[19] !== t3 || $[20] !== t5) {
    t12 = <div className={t3}>{t5}{t11}</div>;
    $[18] = t11;
    $[19] = t3;
    $[20] = t5;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== data.image || $[23] !== data.slug || $[24] !== data.title) {
    t13 = <CaseStudyImageHover imgSrc={data.image} title={data.title} slug={data.slug} imageClassName="object-contain md:object-cover object-center" />;
    $[22] = data.image;
    $[23] = data.slug;
    $[24] = data.title;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== t12 || $[27] !== t13 || $[28] !== t2) {
    t14 = <div className="w-full flex flex-col md:flex-row p-5 md:p-6 lg:p-8 gap-6 md:gap-8 lg:gap-10 lg:justify-between rounded-2xl overflow-hidden items-stretch min-h-90 lg:min-h-130" style={t2}>{t12}{t13}</div>;
    $[26] = t12;
    $[27] = t13;
    $[28] = t2;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  return t14;
};
export default CaseStudyCard;
function _temp(c) {
  return c.toUpperCase();
}